import React from 'react';

const Icon = ({ size = '44', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 44 44" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black" strokeWidth="1.992" strokeLinecap="round" strokeLinejoin="round">
                <path d="M37.45 7.379H14.206v11.954H37.45c1.1 0 1.992-.892 1.992-1.992V9.37c0-1.1-.892-1.992-1.992-1.992ZM34.13 33.28V19.334h-6.642V33.28a3.32 3.32 0 0 0 6.641 0ZM6.237 16.676v-6.64h2.186c.31 0 .614-.073.89-.211l4.893-2.446v11.954l-4.892-2.446a1.991 1.991 0 0 0-.891-.21H6.237Zm21.251 9.299h2.657m-2.657 3.984h2.657" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M.924.738h42.503v42.503H.924z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
